<template>
	<div class="hdl-auth">
		<div class="hdl-auth-content">
			<div
				class="flex flex-row border border-border-gray px-2 py-4 rounded hover:bg-fill-hover cursor-pointer mb-8"
				@click.prevent="selectWorkspace(workspace)"
				v-for="workspace of workspaces"
				:key="workspace.uuid"
			>
				<workspace-icon
					:workspace="workspace"
					class="mr-2"
				/>
				<div class="mr-2 flex-1">{{ workspace.name }}</div>
			</div>
			<hdl-button
				label="Create new workspace"
				@click.prevent="createNewWorkspace"
				hdl-style="primary"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { FetchResult, KnownFetchResult, fetcher } from '@/common/fetcher';
import { WorkspaceType } from '@/common/interfaces';
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component
export default class WorkspaceSelection extends Vue {
	workspaces: Array<WorkspaceType> = [];

	mounted(): void {
		this.workspaces = [];
		this.fetchWorkspaces();
	}

	fetchWorkspaces(): void {
		fetcher.Get(
			'/api/workspace/all-my/'
		).then(
			(result: KnownFetchResult<{workspaces: Array<WorkspaceType>}>) => {
				if (result.response.ok && result.json.success) {
					this.workspaces = result.json.data.workspaces;
				}
			}
		);
	}

	createNewWorkspace(): void {
		window.location.replace('/account/workspaces/create/');
	}

	selectWorkspace(workspace: WorkspaceType): void {
		fetcher.Post(
			'/account/workspaces/',
			{
				'workspace': workspace.uuid
			}
		).then(
			(result: FetchResult) => {
				if (result.response.ok && result.json.success) {
					window.location.replace('/');
				} else {
					// TODO handle error
				}
			}
		);
	}
}
</script>

<style lang="scss">

</style>
